import { render, staticRenderFns } from "./breeder-litter-list-component.vue?vue&type=template&id=15b43a70&scoped=true&lang=pug"
import script from "./breeder-litter-list-component.js?vue&type=script&lang=js&external"
export * from "./breeder-litter-list-component.js?vue&type=script&lang=js&external"
import style0 from "./breeder-litter-list-component.vue?vue&type=style&index=0&id=15b43a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b43a70",
  null
  
)

export default component.exports